"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Pin = _interopRequireDefault(require("@insided/destination/icons/Pin"));

var PinnedReplyLabel = function PinnedReplyLabel(_ref) {
  var phrase = _ref.phrase;
  return (0, _preact.h)("div", {
    className: "pinned-reply__label"
  }, (0, _preact.h)(_Pin.default, {
    height: 20,
    width: 20
  }), phrase);
};

var _default = PinnedReplyLabel;
exports.default = _default;